module.exports = __webpack_public_path__ + "public/img/Sale01.f6981d81.png";